
import React from 'react'
import { url } from '../helpers/helpers'
import { userContext } from '../context/user'
import Footer from '../components/Footer'
import PanelNav from '../components/PanelNav'
import PanelSidebar from '../components/PanelSidebar'

export default function ProductWiseDetailSales() {

    const [productsList, setProductsList] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [fromDate, setFromDate] = React.useState('')
    const [toDate, setToDate] = React.useState('')

    React.useEffect(() => {
        setLoading(true)
        const formData = new FormData()
        async function fetchData() {
            const response = await fetch(url + 'productWiseDetailSalesAPI/', {
                method: 'POST',
                headers: {
                    'X-CSRFToken': csrftoken,
                },
                body : formData
            })

            if (response.ok == true) {
                const data = await response.json()
                setProductsList(data.final_arr)
                setLoading(false)
            }else{
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    const { user } = React.useContext(userContext)
    if (!user) {
        return window.location = window.location.origin + '/signInPage'
    }

    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    var csrftoken = getCookie('csrftoken');

    const handleFilter = () => {
        if (fromDate && toDate) {
            setLoading(true)
            const formData = new FormData()
            formData.append('from_date', fromDate)
            formData.append('to_date', toDate)
            async function filterData() {
                const response = await fetch(url + 'productWiseDetailSalesAPI/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData
                })

                if (response.ok === true) {
                    const data = await response.json()
                    setProductsList(data.final_arr)
                    setLoading(false)
                }
            }
            filterData()
        } else {
            alert('please fill the data')
        }
    }

    

    return (
        <section>
            {loading && <div id="loader"></div>}
            <PanelNav />
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <PanelSidebar />
                <div style={{ width: '100%', margin: '0 0.5%' }}>

                    <div className="display-div border">
                        <div className="form-group">
                            <label htmlFor="">From Date</label>
                            <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} className='form-control' />
                        </div>
                        <div className="form-group">
                            <label htmlFor="">To Date</label>
                            <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} className='form-control' />
                        </div>
                        <div className='btn-div'>
                            <button onClick={() => handleFilter()} className='btn btn-primary'>Submit</button>
                        </div>
                    </div>

                    {productsList.length > 0 ? <table>
                        <thead style={{ background: 'ghostwhite' }}>
                            <th>Sr. No.</th>
                            <th>Product Name</th>
                            <th>HSN</th>
                            <th>Total Kg</th>
                            <th>Total Profit</th>
                            <th></th>
                            <th></th>
                        </thead>

                        {productsList.map((item, index) => {
                            return <tr>
                                <td>{index + 1}</td>
                                <td>{item.name} {item.category_code} {item.inch}" {item.gram}</td>
                                <td>{item.hsn}</td>
                                <td>{item.total_kg}</td>
                                <td>{item.total_profit}</td>
                                <td><a target='_blank' href={`${url}admin/erpApp/product/${item.id}/change/`}>Edit</a></td>
                                <td><a target='_blank' href={`${url}admin/erpApp/product/${item.id}/delete/`}>Delete</a></td>
                            </tr>
                        })}

                    </table> : <h1>No Data Found Please Wait</h1>}
                </div>
            </div>
            <Footer />
        </section>
    )
}